var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "phone-formatter-input" }, [
    _vm.label
      ? _c("label", { attrs: { for: "phoneNumber" } }, [
          _vm._v(_vm._s(_vm.label)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.description ? _c("small", [_vm._v(_vm._s(_vm.description))]) : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "phone-input-container" }, [
      _c(
        "div",
        {
          staticClass: "country-selector",
          class: { active: _vm.showCountryDropdown },
          on: { click: _vm.toggleCountryDropdown },
        },
        [
          _c("img", {
            staticClass: "flag-icon",
            attrs: {
              src: _vm.getFlagUrl(_vm.selectedCountry.code),
              alt: _vm.selectedCountry.name,
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "dial-code" }, [
            _vm._v(_vm._s(_vm.selectedCountry.dial_code)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "dropdown-arrow" }, [_vm._v("▼")]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "phone-input-wrapper" }, [
        _c("input", {
          ref: "phoneInput",
          staticClass: "phone-input",
          attrs: { type: "text", placeholder: _vm.getPhonePlaceholder() },
          domProps: { value: _vm.formattedPhoneNumber },
          on: {
            input: _vm.onPhoneInput,
            keydown: _vm.onPhoneKeydown,
            paste: _vm.onPhonePaste,
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  placement: "top",
                  theme: "light",
                },
                expression:
                  "{\n                    placement: 'top',\n                    theme: 'light',\n                }",
              },
            ],
            staticClass: "info-icon md-icon",
            attrs: { content: _vm.infoTooltip },
          },
          [_c("span", { staticClass: "md-icon" }, [_vm._v("info")])]
        ),
      ]),
      _vm._v(" "),
      _vm.showCountryDropdown
        ? _c("div", { staticClass: "country-dropdown" }, [
            _c("div", { staticClass: "country-search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.countrySearchQuery,
                    expression: "countrySearchQuery",
                  },
                ],
                ref: "countrySearch",
                attrs: { type: "text", placeholder: "Ülke ara..." },
                domProps: { value: _vm.countrySearchQuery },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.countrySearchQuery = $event.target.value
                    },
                    _vm.filterCountries,
                  ],
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "country-list" },
              _vm._l(_vm.filteredCountries, function (country) {
                return _c(
                  "div",
                  {
                    key: country.code,
                    staticClass: "country-item",
                    class: {
                      selected: _vm.selectedCountry.code === country.code,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectCountry(country)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "flag-icon",
                      attrs: {
                        src: _vm.getFlagUrl(country.code),
                        alt: country.name,
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "country-name" }, [
                      _vm._v(_vm._s(_vm.getCountryDisplayName(country))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "dial-code" }, [
                      _vm._v(_vm._s(country.dial_code)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }